import React from 'react';
import { AvailabilityObject } from '../../types/schemas/abc';
import { CalendarEvent } from '../../hooks/useEvents';
import { EventBlock } from './EventBlock';
import { useWeeklyBuckets } from '../../hooks/useWeeklyBuckets';
import { Stage } from '../../styles/timeline/week.style';

interface WeekEventsOverlayProps {
  weekStart: Date;
  availability: AvailabilityObject | null;
  events?: CalendarEvent[] | null;
  onEventClick?: (eventId: string) => void;
  activeTz?: string;
  homeTz?: string;
}

export const WeekEventsOverlay: React.FC<WeekEventsOverlayProps> = ({
  weekStart,
  availability,
  events,
  onEventClick,
  activeTz,
  homeTz,
}) => {

  const weeklyBuckets = useWeeklyBuckets(weekStart, availability, events, activeTz, homeTz);

  return (
    <div style={{
      position: 'absolute', inset: 0, display: 'grid',
      gridTemplateColumns: 'repeat(7, 1fr)', pointerEvents: 'none'
    }}>
      {weeklyBuckets.map((dayEvents, dayIndex) => (
        <Stage key={dayIndex}>
          {dayEvents.map(ev => (
            <EventBlock
              key={ev.id}
              event={ev}
              onClick={onEventClick}
              activeTz={activeTz}
            />
          ))}
        </Stage>
      ))}
    </div>
  );
};
